export default __webpack_public_path__ + "static/favicon-82ea6e970e20d7dcf712db8b2dd93a1b.png";